import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemProjectDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-system-project-delete',
	path: '/secure/project/DeleteProject.jspa',
};
